import RestService from './RestService';

export async function getNotes(identifier) {
	const res = await RestService.performRestOpNext(`note/get-notes-by-identifier`, {
		identifier
	});
	console.log(res);
	return res.Items;
}

export async function createNote(identifier, note) {
	const res = await RestService.performRestOpNext(`note/create`, { identifier, note });
	console.log(res);
	return res;
}

